export const MOST_RECENT_VERSION = '3.11';
export const DEFAULT_SYSTEM_MODEL = 'cutoff';

export const PROBLEMATIC_VERSIONS = ['3.10', '3.9', '3.7'];
